import React, {useEffect} from 'react'
import apiLink from '../../config.js'

function FooterPDF({idExploit, top}) {
    const [libellRA, setLibelleRA] = React.useState("")
    const [idRA, setidRA] = React.useState("")

    useEffect ( () => {
        //fetch(apiLink + 'getLocalisation/' + idExploit)
        const token = localStorage.getItem('token');
        fetch(apiLink + 'getLocalisation' , {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify({ idExploitation: idExploit })
        })
        .then( (response) => {
          return response.json()
        })
        .then(response =>{
            var city =  response.idCommune
            //fetch(apiLink + 'getCommune/' + city )
            fetch(apiLink + 'getCommune', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              },
              body: JSON.stringify({ idCommune: city })
            })
            .then( (response) => {
            return response.json()
            })
            .then(response =>{
                setLibelleRA(response.libelleRegionAgricole)
                setLibelleRA(prev => {
                    return prev;
                })
                setidRA(response.idRegionAgricole)
                setidRA(prev => {
                    return prev;
                })
            })
        })
    }, [idExploit])
  return (
    <div className='paragraphe num_page_rapport' style={{position: 'relative', top: top, left:'350px'}}>
      {idRA} - {libellRA}
    </div>
  )
}

export default FooterPDF